import { render, staticRenderFns } from "./maintenanceModal.vue?vue&type=template&id=5b487948&"
import script from "./maintenanceModal.vue?vue&type=script&lang=js&"
export * from "./maintenanceModal.vue?vue&type=script&lang=js&"
import style0 from "./maintenanceModal.vue?vue&type=style&index=0&id=5b487948&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports